import { render, staticRenderFns } from "./AdModal.vue?vue&type=template&id=597ae58e"
import script from "./AdModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdModal.vue?vue&type=style&index=0&id=597ae58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports